module.exports = __webpack_public_path__ + "img/GOPR1580.0b967325.png";